module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-13.a12a2068.png";